import { render, staticRenderFns } from "./bscClueManageHighSeas.vue?vue&type=template&id=41871ae4&scoped=true"
import script from "./bscClueManageHighSeas.vue?vue&type=script&lang=js"
export * from "./bscClueManageHighSeas.vue?vue&type=script&lang=js"
import style0 from "./bscClueManageHighSeas.vue?vue&type=style&index=0&id=41871ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41871ae4",
  null
  
)

export default component.exports